import { render, staticRenderFns } from "./通知抵押公告详情.vue?vue&type=template&id=f1810aea&scoped=true"
import script from "./通知抵押公告详情.vue?vue&type=script&lang=js"
export * from "./通知抵押公告详情.vue?vue&type=script&lang=js"
import style0 from "./通知抵押公告详情.vue?vue&type=style&index=0&id=f1810aea&prod&lang=css"
import style1 from "./通知抵押公告详情.vue?vue&type=style&index=1&id=f1810aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1810aea",
  null
  
)

export default component.exports